import { render, staticRenderFns } from "./ViewerManager.vue?vue&type=template&id=4742fbb7&"
import script from "./ViewerManager.vue?vue&type=script&lang=js&"
export * from "./ViewerManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4742fbb7')) {
      api.createRecord('4742fbb7', component.options)
    } else {
      api.reload('4742fbb7', component.options)
    }
    module.hot.accept("./ViewerManager.vue?vue&type=template&id=4742fbb7&", function () {
      api.rerender('4742fbb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/ViewerManager.vue"
export default component.exports